const removeUnderscores = (text: string) => {
  return text.split("_").join(" ");
};

export default removeUnderscores;
